<template>
  <p class="text-center text-base md:text-xl">
    <slot />
  </p>
</template>
